<template>
  <div id="waterSystem">
    <el-row>
      <el-col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="resData.grid"
        :xl="resData.grid"
        v-for="(item, index) in resData.data"
        :key="index"
      >
        <div class="proItem">
          <div class="proTitle">
            <div class="titleWord">{{ item.name }}</div>
            <div class="status">{{ item.status == 1 ? "在线" : "离线" }}</div>
          </div>
          <div class="proMain">
            <div
              class="leftPro"
              :class="{ noTempData: item.temp.length == 0 ? true : false }"
            >
              <div :id="`myChart${index}`" class="echart"></div>
            </div>
            <div class="rightPro" v-if="item.temp.length > 0">
              <div v-for="(n, i) in item.temp" :key="i" class="progressItem">
                <div class="progressTitle">
                  {{ n.name }}
                </div>
                <vm-progress
                  :percentage="n.count"
                  :stroke-width="12"
                  :status="n.status"
                  >{{ n.count }}℃</vm-progress
                >
              </div>
            </div>
          </div>
          <div class="proBott">数据时间：{{ item.date }}</div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="resData.grid" :xl="resData.grid">
        <div class="echarts" id="echartBar"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  props: {
    //   resData:{
    //       type:Object,
    //       default:{}
    //   }
  },
  data() {
    return {
      resData: {
        grid: 8,
        type: "electric",
        data: [
          {
            name: "二级配电柜1",
            status: 1, //1在线  0 离线
            circleNum: 866,
            circle: 86.6,
            date: "2020-12-12 12:12:12",
            status: "exception",
            temp: [
              { count: 42.5, status: "info", name: "电流" },
              { count: 43.5, status: "info", name: "电阻" },
              { count: 44.5, status: "exception", name: "温感" },
              { count: 45.5, status: "info", name: "电压" },
            ],
          },
          {
            name: "二级配电柜2",
            status: 1, //1在线  0 离线
            circleNum: 160,
            circle: 16,
            date: "2020-12-12 12:12:12",
            status: "info",
            temp: [
              { count: 42.5, status: "info", name: "电流" },
              { count: 43.5, status: "info", name: "电阻" },
              { count: 44.5, status: "info", name: "温感" },
              { count: 45.5, status: "exception", name: "电压" },
            ],
          },
          {
            name: "二级配电柜3",
            status: 0, //1在线  0 离线
            circleNum: 520,
            circle: 52,
            status: "info",
            date: "2020-12-12 12:12:12",
            temp: [],
          },
        ],
      },
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.drawMap(
      "electric",
      "myChart0",
      1000,
      1320,
      800,
      false,
      "MA",
      "47%",
      "20%"
    );
    this.drawMap(
      "electric",
      "myChart1",
      100,
      132,
      40,
      false,
      "MA",
      "47%",
      "33%"
    );
    this.drawMap("water", "myChart2", 10, 13.2, 3.2, true, "Mpa", "47%", "10%");
    this.drawBar(240,1000);
  },
  watch: {},
  methods: {
    drawMap(
      type,
      domObj,
      gaugeMax,
      optMax,
      currVal,
      pointerShow,
      subtext,
      left,
      bottom
    ) {
      /**
       * type:系统类型
       * gaugeMax 仪表盘最大值 = optMax/1.32
       * optMax = gaugeMax * 1.32
       * currVal 当前值
       * pointerShow 指针显示
       * subtext 副标题
       * left 左边距
       * bottom 底部边距
       */
      var myChart = this.$echarts.init(document.getElementById(domObj));
      let electricOption = {
        title: {
          show: true,
          text: currVal,
          subtext,
          subtextStyle: {
            align: "center",
          },
          textAlign: "center",
          left: left,
          bottom: bottom,
          textStyle: {
            color: "#333333",
            fontSize: 20,
            align: "center",
          },
        },
        angleAxis: {
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          min: 0,
          max: optMax, //1320
          startAngle: 225,
        },
        radiusAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          //   data: ["a", "b", "c"],
          z: 10,
        },
        polar: {
          radius: "100%",
        },
        series: [
          {
            type: "bar",
            data: [, , currVal], //DT
            z: 1,
            coordinateSystem: "polar",
            barMaxWidth: 12,
            name: "警告事件",
            roundCap: true,
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
              {
                offset: 0,
                color: "#6BBEFF",
              },
              {
                offset: 1,
                color: "#569AF0",
              },
            ]),
            barGap: "-100%",
          },
          {
            type: "bar",
            data: [, , gaugeMax], //DT
            z: 0,
            silent: true,
            coordinateSystem: "polar",
            barMaxWidth: 0,
            name: "",
            roundCap: true,
            color: "#F1F3F5",
            barGap: "-100%",
          },
          //   仪表盘
          {
            name: "Pressure",
            type: "gauge",
            radius: "75%",
            max: gaugeMax,
            detail: {
              //中间的数值字
              show: false,
              formatter: `${currVal}`,
              fontSize: 24,
              fontWeight: "bold",
              offsetCenter: [0, 0],
              color: "#50bfff", //DT
            },
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [1, "#569AF0"],
                ],
                width: 20,
                opacity: 0, //刻度背景宽度
              },
            },
            data: [
              {
                name: "",
                value: currVal,
              },
            ],
            splitLine: {
              length: 3, //长刻度节点线长度
              lineStyle: {
                width: 1,
                color: "#c4c6cc",
              }, //刻度节点线
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: "#c4c6cc",
                width: 1,
              },
              length: 5,
              splitNumber: 3,
            },
            axisLabel: {
              show: false,
              color: "#333",
              fontSize: 12,
            },
            pointer: {
              show: pointerShow,
              length: "70%",
              width: 3,
              itemStyle: {
                color: "#000000",
              },
            },
          },
          //圆环
          {
            type: "pie",
            radius: ["82%", "79%"],
            hoverAnimation: false,
            startAngle: 225,
            endAngle: 0,
            data: [
              {
                name: "",
                value: currVal / gaugeMax,
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                itemStyle: {
                  color: "rgba(0,0,0,0)",
                },
              },
              {
                //进度圆球
                name: "",
                value: 0,
                label: {
                  show: true,
                  position: "inside",
                  backgroundColor: "#569AF0",
                  borderRadius: 8,
                  padding: 8,
                  borderWidth: 1,
                  borderColor: "#ffffff",
                },
              },
              {
                name: "",
                value: 1.32 - currVal / gaugeMax,
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                itemStyle: {
                  color: "rgba(255,255,255,0)",
                },
              },
            ],
          },
        ],
        tooltip: {
          show: false,
        },
      };

      let waterOption = {
        title: {
          show: true,
          text: currVal,
          subtext,
          subtextStyle: {
            align: "center",
          },
          textAlign: "center",
          left: left,
          bottom: bottom,
          textStyle: {
            color: "#333333",
            fontSize: 22,
            align: "center",
          },
        },
        tooltip: {
          show: false,
        },
        angleAxis: {
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          min: 0,
          max: optMax, //1320
          startAngle: 225,
        },
        radiusAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          z: 10,
        },
        polar: {
          radius: "100%",
        },
        series: [
          {
            type: "bar",
            data: [, , gaugeMax], //DT
            z: 0,
            silent: false,
            coordinateSystem: "polar",
            barWidth: 6,
            name: "",
            roundCap: true,
            color: "#F1F3F5",
            barGap: "-100%",
          },
          {
            name: "Pressure",
            type: "gauge",
            radius: "80%",
            max: gaugeMax,
            detail: {
              //中间的数值字
              show: false,
            },
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [0, "#DE585D"],
                  [1, "#DE585D"],
                ],
                width: 20,
                opacity: 0, //刻度背景宽度
              },
            },
            data: [
              {
                name: "",
                value: currVal,
              },
            ],
            splitLine: {
              length: 3, //长刻度节点线长度
              lineStyle: {
                width: 1,
                color: "#c4c6cc",
              }, //刻度节点线
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: "#c4c6cc",
                width: 1,
              },
              length: 5,
              splitNumber: 2,
            },
            axisLabel: {
              show: true,
              color: "#333",
              fontSize: 12,
            },
            pointer: {
              show: pointerShow,
              length: "65%",
              width: 3,
              itemStyle: {
                color: "#000000",
              },
            },
          },
        ],
      };

      // 基于准备好的dom，初始化echarts实例
      if (type == "electric") {
        myChart.setOption(electricOption);
      } else if (type == "water") {
        myChart.setOption(waterOption);
      }
    },
    drawBar(data,max) {
      var barChart = this.$echarts.init(document.getElementById("echartBar"));
      let barOption = {
        tooltip: {
          show: false,
        },
        title: {
          show: true,
          text: data,
          subtext:'Mpa',
          subtextStyle: {
            align: "center",
          },
          left: '80%',
          bottom: '38%',
          textAlign: "center",
          textStyle: {
            color: "#333333",
            fontSize: 20,
            align: "center",
          },
        },
        xAxis: {
          data: ["百分比"],
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
            textStyle: {
              color: "#e54035",
            },
          },
        },
        yAxis: {
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        series: [
          {
            name: "最上层立体圆",
            type: "pictorialBar",
            symbolSize: [65, 15],
            symbolOffset: [0, -9],
            z: 12,
            itemStyle: {
              normal: {
                color: "#E9E9E9",
              },
            },
            data: [
              {
                value: max,
                symbolPosition: "end",
              },
            ],
          },
          {
            name: "中间立体圆",
            type: "pictorialBar",
            symbolSize: [65, 15],
            symbolOffset: [0, -9],
            z: 12,
            label: {
              show: false,
              position: ['90%', '0%'],
              distance: 12,
              color: "#333333",
              fontSize: 26,
              formatter: "{c}",
            },
            itemStyle: {
              normal: {
                color: "#89B9F5",
              },
            },
            data: [
              {
                value: data,
                symbolPosition: "end",
              },
            ],
          },
          {
            name: "最底部立体圆",
            type: "pictorialBar",
            symbolSize: [65, 15],
            symbolOffset: [0, 9],
            z: 12,
            
            itemStyle: {
              normal: {
                color: "#89B9F5",
              },
            },
            data: [max - data],
          },
          {
            //底部立体柱
            stack: "1",
            type: "bar",
            itemStyle: {
              normal: {
                color: "#90BDF5",
                opacity: 0.7,
              },
            },
            silent: false,
            barWidth: 65,
            barGap: "-100%", // Make series be overlap
            data: [data],
          },
          {
            //上部立体柱
            stack: "1",
            type: "bar",
            itemStyle: {
              normal: {
                color: "#EAEEF3",
                opacity: 0.7,
              },
            },
            silent: true,
            barWidth: 65,
            barGap: "-100%", // Make series be overlap
            data: [max - data],
          },
        ],
      };
      barChart.setOption(barOption);
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
#waterSystem {
  .echart {
    width: 180px;
    height: 180px;
  }
  .echarts {
    width: 280px;
    height: 280px;
  }
  .proItem {
    padding: 3px 8px;
    border: 1px solid #ccc;
    .proTitle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 40px;
      color: #333;
      font-size: 16px;
      .status {
        background: rgba(37, 176, 173, 0.04);
        border-radius: 2px;
        color: #25b0ad;
        padding: 0px 6px;
        height: 30px;
        line-height: 30px;
        margin-right: 2%;
        font-size: 14px;
      }
    }
    .proMain {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      .leftPro {
        width: 30%;
        text-align: center;
      }
      .noTempData {
        display: flex;
        justify-content: center;
        width: 100%;
      }
      .rightPro {
        width: 60%;
        .progressItem {
          overflow: hidden;
          width: 90%;
          text-align: right;
          margin-left: 10%;
          .progressTitle {
            float: left;
            color: #999999;
            font-size: 12px;
          }
        }
        /deep/.vm-progress-bar {
          width: 90%;
        }
        /deep/ .vm-progress {
          height: 30px;
          float: left;
          width: 90%;
        }
        /deep/ .vm-progress-bar__outer {
          border-radius: 0;
        }
        /deep/ .vm-progress-bar__inner {
          border-radius: 0;
        }
      }
    }
    .proBott {
      line-height: 40px;
      color: #999999;
      font-size: 14px;
    }
  }
}
</style>
